var _path, _g, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 96,
    viewBox: "0 0 122 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.383 0H6.25129C2.7988 0 0 2.85361 0 6.37372V89.0498C0 92.5699 2.7988 95.4235 6.25129 95.4235H115.383C118.836 95.4235 121.634 92.5699 121.634 89.0498V6.37372C121.634 2.85361 118.836 0 115.383 0Z",
    fill: "url(#paint0_linear_1123_652)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_652)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.561 42.8279H103.139V50.324C103.139 52.1774 101.627 53.6911 99.7749 53.6911H92.0131L87.3833 56.0298L81.5608 53.6911V42.8279H81.561Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9255 31.9501H99.7749C101.627 31.9501 103.139 33.4638 103.139 35.3172V40.8872H81.561V35.3172C81.561 33.4638 83.0736 31.9501 84.9255 31.9501Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.561 39.2084H103.139V44.5018H81.561V39.2084Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6356 39.2084H101.399H103.139V35.3172C103.139 34.0508 102.432 32.9447 101.399 32.3721C100.914 32.1053 100.362 31.9499 99.7748 31.9499H95.271C97.1229 31.9499 98.6355 33.4636 98.6355 35.317V39.2084H98.6356Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6355 44.5018H101.399H103.139V42.8279V40.8872V39.2084H101.399H98.6355V40.8872V42.8279V44.5018Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6355 44.5018V50.3242C98.6355 52.1776 97.1229 53.6913 95.271 53.6913H99.7748C100.361 53.6913 100.914 53.5409 101.399 53.2741C102.432 52.6967 103.139 51.5905 103.139 50.3242V44.5018H101.399H98.6355Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5612 53.6913H92.0135V58.4994C92.0135 59.6542 91.0682 60.5954 89.9193 60.5954H55.8877C55.8877 57.5727 55.8877 56.0346 58.2001 56.0346L62.8057 56.0298C65.7049 56.025 67.6052 55.2826 68.6669 53.6911H81.5612V53.6913Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9921 60.5956H89.9188C91.6737 63.6522 93.0845 67.3252 91.8676 74.3506C89.8314 67.4221 69.1499 70.1878 67.0265 78.1836H44.207C43.3441 76.2282 42.5296 74.2972 41.8169 72.3468H48.2502C61.2621 67.4366 57.0784 69.6248 59.9921 60.5956V60.5956Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.145 41.8139C58.5911 44.1622 59.1971 46.4766 59.8757 48.4464L66.4541 51.0239L73.7893 48.4464C73.5323 34.5651 68.345 27.9084 63.9333 25.7542C62.3432 24.5434 60.7143 24.0874 60.7143 24.0874C60.7143 24.0874 58.5715 27.5154 58.4599 27.5154C57.6358 29.4756 57.3256 32.0326 57.3788 34.7932L58.145 41.8139Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7897 48.4464H59.876C56.6714 48.7957 52.73 51.2363 52.73 58.7954V66.7185L55.8876 68.5993L59.9922 66.7185V60.5954C59.9922 57.5727 59.9922 56.0346 62.3046 56.0346L66.9102 56.0298C69.8093 56.025 71.7097 55.2826 72.7714 53.6911C73.5908 52.4638 73.9059 50.7316 73.7897 48.4464V48.4464Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7898 48.4464C73.5328 34.5651 68.3455 27.9084 63.9338 25.7542C63.2794 26.215 62.5521 26.5936 61.7522 26.875C65.6597 29.8297 69.5768 36.4331 69.7998 48.4464H73.7898Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7897 48.4464H69.7998C69.9162 50.7316 69.6011 52.4638 68.7818 53.6913C68.1128 54.6957 67.1044 55.5447 65.7227 56.03H66.9105C69.8096 56.0251 71.71 55.2827 72.7717 53.6913C73.5908 52.4638 73.9059 50.7316 73.7897 48.4464V48.4464Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0266 78.1836C67.0266 71.0077 72.7133 65.2921 79.7283 65.2921C85.4344 65.2921 90.263 69.0766 91.8677 74.3506C92.1974 75.4325 92.3913 76.5825 92.4252 77.776C92.4398 78.2418 92.1197 78.1836 91.6834 78.1836C83.4661 78.1836 75.2439 78.1788 67.0266 78.1836V78.1836Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2214 78.1836H89.5553C89.279 83.3945 85.0564 87.5381 79.8884 87.5381C74.7203 87.5381 70.4977 83.3945 70.2214 78.1836V78.1836Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1258 76.1215L37.7592 79.9497C36.7023 84.5445 32.121 87.4167 27.53 86.359C22.9342 85.3013 20.0689 80.7163 21.1258 76.1215V76.1215Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8799 71.4588C22.2312 68.0382 26.3132 66.0538 30.5795 66.4808C38.1036 68.0722 40.5518 72.5699 41.0414 78.1787C41.0318 78.9404 40.9493 79.7071 40.7844 80.4737C40.736 80.6872 40.5953 80.5999 40.3626 80.5465L37.7591 79.9496L21.1257 76.1215L19.8797 75.8353L18.1394 75.4325C18.4739 73.9673 19.0751 72.6282 19.8799 71.4588Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5649 66.4614L37.2843 43.2112L40.3094 41.8575L43.6933 43.2112C39.2477 55.5351 40.4887 64.1373 43.4898 72.3468C44.2073 74.2973 45.0217 76.2282 45.8799 78.1836H41.0463L30.5649 66.4614Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3725 17.1421L59.2554 15.4634C60.0553 15.5361 62.3436 17.4576 62.3436 18.6608L60.6662 27.1904C59.9681 27.3991 59.2263 27.5155 58.4603 27.5155C54.262 27.5155 50.8586 24.1047 50.8586 19.9028C50.8586 18.9276 51.0379 17.9959 51.3725 17.1421V17.1421Z",
    fill: "#FFECE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8271 17.1421C48.8271 11.7177 53.1225 7.32678 58.4262 7.32678C63.7299 7.32678 68.0252 11.7177 68.0252 17.1421C68.0252 20.7227 66.5707 23.9056 63.9334 25.7542C62.9929 26.4189 61.8972 26.909 60.6659 27.1904V18.6607C60.6659 17.4574 60.0551 17.2148 59.2551 17.142H51.3723H48.8271V17.1421Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4038 8.77743C54.8631 7.85554 56.5842 7.32678 58.4263 7.32678C63.73 7.32678 68.0253 11.7177 68.0253 17.1421C68.0253 20.7227 66.5709 23.9056 63.9335 25.7542C63.2645 26.2248 62.5227 26.6082 61.7082 26.8896C63.6571 24.9148 64.714 22.0814 64.714 18.9567C64.714 13.2897 60.2199 8.69492 54.6786 8.69492C54.2473 8.69492 53.8207 8.71916 53.4038 8.77743Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.73 66.7185H59.9924V71.2939C59.9924 72.2741 59.4592 72.3468 58.6737 72.3468H48.2506C48.0419 67.7568 50.8199 66.7185 52.73 66.7185Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4898 72.3468C40.4889 64.1375 39.2477 55.5351 43.6933 43.2112H41.2014C41.1918 43.2112 41.182 43.2112 41.1724 43.2112H40.2755C35.83 55.5351 37.0661 64.1373 40.0718 72.3468C40.7845 74.2973 41.599 76.2282 42.462 78.1836H44.2073H45.8799C45.0218 76.2282 44.2073 74.2972 43.4898 72.3468Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0414 78.1787L30.5795 66.4808C29.4984 66.3741 28.4269 66.4177 27.3943 66.607L37.449 77.8487C37.4394 78.5036 37.3763 79.1684 37.2503 79.8331L37.7593 79.9495L40.3628 80.5463C40.5955 80.5996 40.7361 80.6871 40.7846 80.4736C40.9493 79.7071 41.0316 78.9404 41.0414 78.1787V78.1787Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9188 60.5956H59.9922V63.2301H84.5813C86.5834 63.2301 87.5337 64.0937 88.3143 65.8453C88.9881 67.364 89.0028 67.8589 89.3081 69.6929C90.4571 71.0271 91.3394 72.6089 91.8678 74.3506C93.0846 67.325 91.6738 63.6522 89.9188 60.5956V60.5956Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3081 69.6927C86.981 66.9901 83.5535 65.2921 79.7285 65.2921C78.7686 65.2921 77.8377 65.3989 76.9409 65.5978C82.6665 66.8932 86.6709 71.9489 86.8454 77.776C86.855 78.0962 86.7096 78.169 86.477 78.1836H89.5554H91.6838C92.1201 78.1836 92.4401 78.2418 92.4255 77.776C92.3917 76.5825 92.1978 75.4325 91.868 74.3506C91.8584 74.3166 91.8486 74.2875 91.839 74.2585C91.839 74.2585 91.839 74.2585 91.839 74.2537C91.3056 72.5505 90.4378 71.0027 89.3081 69.6927Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2502 79.8331L21.1256 76.1215C20.9463 76.8832 20.8832 77.6498 20.9123 78.3971L33.7109 81.3422L34.2151 81.4586C33.74 83.5449 32.5329 85.2769 30.9282 86.4464C34.2005 85.8689 36.9688 83.3945 37.7591 79.9497L37.2502 79.8331Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4766 78.1836H70.2212C70.2745 79.2024 70.483 80.1826 70.8175 81.0995H82.1424H85.2209C85.0997 83.3799 84.2271 85.4516 82.8502 87.0672C86.588 85.8397 89.3367 82.3512 89.5549 78.1834H86.4766V78.1836Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0132 58.4994V53.6913H85.4441V58.4994C85.4441 59.6542 84.4988 60.5954 83.3499 60.5954H89.9189C91.0679 60.5955 92.0132 59.6542 92.0132 58.4994Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8975 19.0877H57.3744C58.1743 19.1604 58.7852 19.4079 58.7852 20.6112V27.5057C59.4348 27.4766 60.065 27.3699 60.6662 27.1902V18.6607C60.6662 17.4574 60.0554 17.2148 59.2554 17.142H51.3726C51.135 17.7534 50.9702 18.4083 50.8975 19.0877V19.0877Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8832 35.8898L44.9538 38.8882C45.3999 39.2859 44.8957 43.3422 44.595 43.2112H37.2842H34.0505V36.5351C34.0505 35.2202 34.7342 35.5112 35.8832 35.8898V35.8898Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1813 43.2112H48.4201H44.5951C42.1323 43.2112 42.0596 39.1259 44.9539 38.8882L49.1813 38.5485L50.3157 40.9503L49.1813 43.2112Z",
    fill: "#FFECE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3792 34.7932L58.8965 33.488C62.6973 30.213 67.5018 35.7394 62.4211 39.0386L58.1452 41.8139L55.9926 43.2112H49.1812V38.5485L53.4134 38.204L57.3792 34.7932Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1814 43.2112V40.9503H48.2748H47.7852H47.0192H43.1942C43.0487 40.9503 42.9129 40.9406 42.7821 40.9114C42.6415 42.037 43.2767 43.2112 44.5953 43.2112H48.4204H49.1814Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4211 39.0386C65.4947 37.0396 64.9516 34.2304 63.2017 33.0466C63.3423 34.2595 62.7654 35.652 61.0201 36.7826L57.6895 38.9416L56.749 39.5579L54.5964 40.9504H49.1812V43.2114H55.9926L58.1452 41.814L62.4211 39.0386Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9537 38.8882L41.3032 37.6849C40.0815 38.9949 39.49 41.5469 40.2754 43.2112H43.6932H44.595C43.2763 43.2112 42.6413 42.037 42.7817 40.9114C42.9077 39.9362 43.6108 38.9997 44.9537 38.8882V38.8882Z",
    fill: "#FFC269"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5459 15.9614H15.4805C15.0475 15.9614 14.6321 15.786 14.3259 15.4738C14.0197 15.1615 13.8477 14.7381 13.8477 14.2965C13.8477 13.855 14.0197 13.4315 14.3259 13.1193C14.6321 12.8071 15.0475 12.6317 15.4805 12.6317H28.5459C28.979 12.6317 29.3943 12.8071 29.7005 13.1193C30.0067 13.4315 30.1788 13.855 30.1788 14.2965V14.2965C30.1788 14.7381 30.0067 15.1615 29.7005 15.4738C29.3943 15.786 28.979 15.9614 28.5459 15.9614V15.9614Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M34.7392 24.1157H15.4805C15.0475 24.1157 14.6321 23.9403 14.3259 23.6281C14.0197 23.3158 13.8477 22.8924 13.8477 22.4509V22.4509C13.8477 22.0091 14.0196 21.5854 14.3258 21.2727C14.6319 20.9601 15.0472 20.7842 15.4805 20.7835H34.7392C35.1725 20.7842 35.5878 20.9601 35.8939 21.2727C36.2001 21.5854 36.3721 22.0091 36.3721 22.4509C36.3721 22.8924 36.2 23.3158 35.8938 23.6281C35.5876 23.9403 35.1723 24.1157 34.7392 24.1157V24.1157Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1123_652",
    x1: -8.02786,
    y1: -86.1674,
    x2: 58.8297,
    y2: 125.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9552FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white",
    transform: "translate(18.1394 4.93234)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/motor.dff1e74da893bc809c0017cec8d7db7c.svg";
export { ForwardRef as ReactComponent };